import styled from 'styled-components';

export const SelectWrapper = styled.div`
  padding: ${({ theme }) => theme.spacing[8]};
  padding-bottom: ${({ theme }) => theme.spacing[2]};
`;
